import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { CardCarousel } from './components/CardCarousel';
import { ReadyToSharePostsCardPreviewVariant1 } from './components/ReadyToSharePostsCard';
import { RecommendedGroupsCardPreview } from './components/RecommendedGroupsCard';
import { SocialContentPreviewLoadingVariant1 } from './components/SocialContent/components/SocialContentCard/variant1';

export function Variant1(): JSX.Element {
	const items = [
		{
			key: 'recommended-groups',
			component: <RecommendedGroupsCardPreview />,
		},
		{
			key: 'ready-to-share',
			component: <ReadyToSharePostsCardPreviewVariant1 />,
		},
		{
			key: 'social-content',
			component: <SocialContentPreviewLoadingVariant1 />,
		},
		{
			key: 'recommended-groups2',
			component: <RecommendedGroupsCardPreview />,
		},
	];
	return (
		<div className="w-full px-1 py-2 md:px-12 md:py-12">
			<div className="mb-4">
				<Text variant="heading" size="small" as="h3" className="text-typography-strong">
					{/* TODO: Add translation here */}
					Grow your petition
				</Text>
			</div>
			<CardCarousel items={items} fullWidthItems={false} />
		</div>
	);
}
